const TrackInfoRowsLoading = ({
    hideSource = false,
    includesVerticalCardPadding = true,
    announce = true,
}) => (
    <div
        className='libraryTrackRowsLoading trackInfoRowsVerticalList'
        role={announce ? 'status' : undefined}
        aria-live={announce ? 'polite' : undefined}
        aria-label={announce ? 'Loading episodes' : undefined}
    >
        {[0, 1, 2].map((index) => (
            <div
                key={index}
                className={`trackInfoRow trackInfoRowFlat libraryTrackInfoRowSkeleton${includesVerticalCardPadding ? '' : ' trackInfoRowCompact'}`}
                aria-hidden='true'
            >
                <div className='trackInfoLayout'>
                    {!hideSource && (
                        <div className='libraryTrackInfoRowSkeletonBlock libraryTrackInfoRowSkeletonArtwork' />
                    )}
                    <div className='trackInfoContent libraryTrackInfoRowSkeletonContent'>
                        <div className='libraryTrackInfoRowSkeletonTitleLines'>
                            <div className='libraryTrackInfoRowSkeletonBlock libraryTrackInfoRowSkeletonTitle' />
                            <div className='libraryTrackInfoRowSkeletonBlock libraryTrackInfoRowSkeletonTitle libraryTrackInfoRowSkeletonTitleShort' />
                        </div>
                        <div className='libraryTrackInfoRowSkeletonBlock libraryTrackInfoRowSkeletonMeta' />
                        <div className='libraryTrackInfoRowSkeletonBlock libraryTrackInfoRowSkeletonPlay' />
                    </div>
                </div>
            </div>
        ))}
    </div>
);

export default TrackInfoRowsLoading;
